import { render } from "./Dostawcy.vue?vue&type=template&id=377318fc&scoped=true&lang=pug"
import script from "./Dostawcy.vue?vue&type=script&lang=js"
export * from "./Dostawcy.vue?vue&type=script&lang=js"

import "./Dostawcy.vue?vue&type=style&index=0&id=377318fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-377318fc"

export default script